import React from 'react';
// import { FieldError } from 'react-hook-form';

import { OrderType } from '@/generated/graphql';
import { MarketType } from '@/types';
import { CurrencyInput, DateInput, Input, Select } from '@/components/form/';
import { Currency } from '@/helpers/currency';
import { todayDate } from '@/helpers/date';

type Props = {
  market?: MarketType;
  errors?: any;
  register: (any: any) => any;
};

export const OrderDetails: React.FC<Props> = ({ market, errors, register }) => (
  <div className="grid grid-cols-2 gap-y-6 gap-x-4">
    <div className="sm:col-span-3">
      <Select
        id="type"
        name="order.type"
        label="Operación"
        defaultValue={OrderType.Buy}
        options={[
          { label: 'Compra', value: OrderType.Buy },
          { label: 'Venta', value: OrderType.Sell },
        ]}
        error={errors?.type}
        register={register}
        required
      />
    </div>

    <div className="sm:col-span-3">
      <DateInput
        label="Fecha"
        id="date"
        name="order.date"
        defaultValue={todayDate}
        error={errors?.date}
        register={register}
        required
      />
    </div>

    <div className="sm:col-span-3">
      <Input
        label="Cantidad"
        id="shares"
        name="order.shares"
        error={errors?.shares}
        register={register}
        valueAsNumber
        hasDecimalPart
        required
      />
    </div>

    <div className="sm:col-span-3">
      <CurrencyInput
        label="Precio"
        id="price"
        name="order.price"
        currency={(market?.currency as Currency) ?? 'EUR'}
        step={0.01}
        error={errors?.price}
        register={register}
        valueAsNumber
        required
      />
    </div>

    <div hidden={market?.country !== 'US'} className="sm:col-span-3">
      <Input
        label="Tipo de cambio"
        id="exchangeRate"
        name="order.exchangeRate"
        error={errors?.exchangeRate}
        register={register}
        valueAsNumber
        hasDecimalPart
        required
      />
    </div>

    <div className="sm:col-span-3">
      <CurrencyInput
        label="Comisión"
        id="commissions"
        name="order.commissions"
        currency="EUR"
        step={0.01}
        error={errors?.commissions}
        register={register}
        valueAsNumber
      />
    </div>
  </div>
);
